import picture from "@/assets/hero-method.jpg?w=640;960;1280;1920&format=avif;webp;jpg&quality=70&as=picture";
import type { MarketingPicture } from "@/lib/marketing-images";

export const heroMethodPic = picture as MarketingPicture;
